import { render, staticRenderFns } from "./DuiXiangGuanLi.vue?vue&type=template&id=6b02fd53&scoped=true&"
import script from "./DuiXiangGuanLi.vue?vue&type=script&lang=js&"
export * from "./DuiXiangGuanLi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b02fd53",
  null
  
)

export default component.exports